import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/accountManager`;

export interface SetSellerConfigurationAccountManagerCommandArgs {
  sellerId: string;
  accountStatus: string;
  customerService: boolean;
}

export default async function setSellerConfigurationAccountManagerCommand(
  payload: SetSellerConfigurationAccountManagerCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const { sellerId, ...json } = payload;
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
      json,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
